<template>
    <div
        v-if="showAddDialog"
        class="dialog-mask">
        <div class="add-user-area">
            <div class="add-user-title">
                批量下载货柜二维码
            </div>
            <a-input-group size="large">
                <div class="input-line">
                    <div class="input-label">
                        二维码下载数
                    </div>
                    <a-input-number
                        class="number-box"
                        :min="1"
                        :max="100000"
                        :defaultValue="1"
                        @change="onChange" />
                </div>
            </a-input-group>
            <div
                class="message"
                v-if="showError">
                {{ showMessage }}
            </div>
            <div class="submit-button-area">
                <a-button
                    v-on:click="addConfirm"
                    class="submit-button"
                    size="large"
                    type="primary">
                    下载
                </a-button>
            </div>
            <a-icon
                v-on:click="addCancel"
                class="close-button"
                type="close" />
        </div>
    </div>
</template>
<script>
 import Vue from 'vue';

 import { isEmptyOrWhitespace } from "../util/utils.js"
 import message from "ant-design-vue/lib/message";

 import InputGroup from "ant-design-vue/lib/input/Group";
 import InputNumber from "ant-design-vue/lib/input-number";
 import Radio from "ant-design-vue/lib/radio/Radio";
 import RadioGroup from "ant-design-vue/lib/radio/Group";
 import RadioButton from "ant-design-vue/lib/radio/RadioButton";

 Vue.component(InputGroup.name, InputGroup);
 Vue.component(InputNumber.name, InputNumber);
 Vue.component(RadioGroup.name, RadioGroup);
 Vue.component(RadioButton.name, RadioButton);
 Vue.component(Radio.name, Radio);

 export default {
     name: 'DownloadQRCodeDialog',
     data() {
         return {
             showAddDialog: false,
             showError: false,
             addUserError: false,
             showMessage: "",
             downloadNumber: 1,
         }
     },
     components: {
     },
     props: {
     },
     computed: {
     },
     methods: {
         show() {
             this.init()
             this.showAddDialog = true
         },
         init() {
             this.showError = false
             this.showMessage = ""
         },
         addCancel() {
             this.showAddDialog = false
         },
         addConfirm() {
             var that = this
             this.addUser(
                 function(response) {
                     that.showAddDialog = false

                     message.success("货柜二维码正在下载")

                     that.downloadQRCode(response)
                 },
                 function(errorCode) {
                     that.showError = true
                     that.showMessage = "错误码：" + errorCode
                 }
             )
         },
         onChange(value) {
             this.downloadNumber = value
         },
         addUser(successCallback, failedCallback) {
             this.addUserError = false

             var url = process.env.VUE_APP_API_SERVER + '/machine-box'
             var accessToken = localStorage.getItem('accessToken')
             var data = {
                 num: this.downloadNumber
             }

             console.log(data)

             var that = this
             fetch(url, {
                 method: "POST",
                 body: JSON.stringify(data),
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }).then(res => {
                 if (!res.ok) { throw res }
                 return res.json()
             }).catch(error => {
                 that.addUserError = true

                 failedCallback(error.status)
             }).then(response => {
                 if (!that.addUserError) {
                     successCallback(response)
                 } else {
                     that.addUserError = false
                 }
             })
         },
         downloadQRCode(response) {
             var images = []

             for (var i = 0; i < response.length; i++) {
                 images.push(
                     response[i].MachineSerialNum
                 )
             }

             sessionStorage.setItem("renderQRCodeInfo", JSON.stringify(images))

             this.$router.push("/renderQRCode")
         }
     },
 }
</script>

<style scoped>
 .dialog-mask {
     position: absolute;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     background-color: rgba(0, 0, 0, 0.8);
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     z-index: 1000;
 }
 .add-user-area {
     padding: 30px;
     background-color: #FFF;
     border: 1px solid #DDD;
     border-radius: 5px;
     box-shadow: 0px -5px 10px -10px #858484;
     width: 450px;
     height: 300px;
     position: absolute;
     display: flex;
     flex-direction: column;
     align-items: center;
 }
 .add-user-title {
     font-size: 24px;
     margin-bottom: 40px;
 }
 .submit-button-area {
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     align-items: center;
 }
 .submit-button {
     width: 150px;
     margin-left: 10px;
     margin-right: 10px;
 }
 .input-area {
     width: 100%;
 }
 .input-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 10px;
 }
 .input-label {
     width: 120px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }

 .input-type-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 12px;
 }

 .input-type-label {
     width: 88px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }

 .close-button {
     position: absolute;
     top: 10px;
     right: 10px;
     cursor: pointer;
     color: #AAA;
 }
 .close-button:hover {
     color: #666;
 }
 .message {
     margin-top: 10px;
     color: #D80E3B;
     font-size: 14px;
 }

 /* 禁止 Chrome 自动填充修改 input 样式 */
 input:-webkit-autofill,
 input:-webkit-autofill:hover,
 input:-webkit-autofill:focus,
 input:-webkit-autofill:active {
     -webkit-transition-delay: 99999s;
     -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
 }

 .number-box {
     width: 200px;
 }
</style>
